require('es6-promise').polyfill();
require('isomorphic-fetch');
var $selfCancelingAjax = require('../common/self-canceling-ajax');

let hasMemberPricing = undefined;

module.exports = {
	validateMemberNumber: function validateMemberNumber() {
		eventHasMemberPricing().then((hasMemberPricing) => {
			if (hasMemberPricing === false) {
				return;
			}

			var $memberNumber = window.jQuery('#memberNumber');

			//set to invalid until we're done checking
			$memberNumber.data('valid', false);
			$memberNumber.data('validation', 'checking');
			window.jQuery('#memberNumberError_checking').removeClass('hide');
			window
				.jQuery(
					'#memberNumberError_notfound,#memberNumberError_name,#memberNumberError_inactive,#memberNumberError_valid'
				)
				.addClass('hide');

			var memberNumber = $memberNumber.val() || '';
			var ln1 = window.jQuery('#lastName').val();
			var ln2 = window.jQuery('#maidenName').val();

			$selfCancelingAjax(
				'validateMemberNumber',
				{
					url:
						'/index.cfm/events:register/validateMemberNumber?memberNumber=' +
						memberNumber +
						'&lastName1=' +
						ln1 +
						'&lastName2=' +
						ln2,
					type: 'GET'
				},
				function (response) {
					window.jQuery('#memberNumberError_checking').addClass('hide');

					if (response.valid) {
						$memberNumber.data('valid', true);
						$memberNumber.data('validation', '');
						if (memberNumber !== '') {
							window.jQuery('#memberNumberError_valid').removeClass('hide');
						}
					} else {
						$memberNumber.data('valid', false);
						$memberNumber.data('validation', response.error);

						if (response.error === 'name') {
							window.jQuery('#memberNumberError_name').removeClass('hide');
						} else if (response.error === 'not found') {
							window.jQuery('#memberNumberError_notfound').removeClass('hide');
						} else if (response.error === 'inactive') {
							window.jQuery('#memberNumberError_inactive').removeClass('hide');
						}
					}
				},
				function (jqxhr, status, error) {
					console.log(error, jqxhr);
					window.jQuery('#memberNumberError_checking').addClass('hide');
					$memberNumber.data('valid', false);
					$memberNumber.data('validation', 'error');
				}
			);
		});
	},
	isMemberNumberValid: function isMemberNumberValid() {
		var $memberNumber = window.jQuery('#memberNumber');

		//for when membership module is disabled OR when the event is not set for members only (hence the required class attr)
		if ($memberNumber.length === 0) {
			return true;
		}

		if ($memberNumber.data('valid')) {
			window.jQuery('#memberNumberError_notfound,#memberNumberError_name,#memberNumberError_inactive').addClass('hide');
			return true;
		}
		return false;
	}
};

const eventHasMemberPricing = () => {
	// hacky cache mechanism
	if (hasMemberPricing === undefined) {
		return fetch('/index.cfm/events:register/memberPricingAvailable?eventId=' + window.iq.eventId)
			.then((response) => response.json())
			.then((json) => {
				hasMemberPricing = json.hasMemberPricing;
				return json.hasMemberPricing;
			});
	}

	return Promise.resolve(hasMemberPricing);
};
